<!-- Uploader.vue -->
<!-- HTML Template -->
<template>
    <div class="add-photo">
        <form enctype="multipart/form-data" novalidate class="add-photo__form">
            <input type="file" multiple="true" accept=".jpg,.jpeg,.gif,.png" :name="uploadFieldName" :disabled="isSaving || is_disabled" @change="uploadFiles($event.target.name, $event.target.files); fileCount = $event.target.files.length" class="input-file" id="uploadPhotosInput">
        </form>

        <div class="add-photo__text-container">
            <div class="add-photo__plus"><img src="/img/add.svg" alt=""></div>
            <template v-if="is_large">
              <button class="button button-plus"></button>
              <p class="button-text text-primary-blue mb-10">{{ upload_files }}</p>
              <p class="caption caption-bold text-secondary">{{ caption }}</p>
            </template>
            <template v-else>
              <p class="text-center subtitle text-secondary" v-if="isInitial">
              {{ upload_files }}
              </p>
              <p class="text-center subtitle text-secondary" v-if="isSaving">
              Uploading {{ fileCount }} files...
              </p>
              <p class="text-center subtitle text-secondary" v-if="isFailed">
              Upload failed...
              </p>
              <p class="text-center subtitle text-secondary" v-if="isSuccess">
              {{ upload_more_files }}
              </p>
            </template>
        </div>
    </div>
</template>

<!-- Javascript -->
<script>
  const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
  const TYPE_FLOOR_PLANS = 'floor_plans';
  const TYPE_LISTING_PHOTOS = 'listing_photos';
  const TYPE_GUEST_LISTING_PHOTOS = 'guest_listing_photos';

  export default {
    name: 'uploader',
    props: {
        listing_id: Number,
        total: {
          type: Number,
          default: 0
        },
        is_large: {
          default: false,
          type: Boolean
        },
        is_disabled: {
          default: false,
          type: Boolean
        },
        type: String,
        upload_files: {
          type: String,
          default: 'Upload photos'
        },
        caption: {
          type: String,
          default: 'Max file size: 20Mb.'
        },
        upload_more_files: {
          type: String,
          default: 'Upload more photos'
        }
    },
    data() {
      return {
        uploadedFiles: [],
        uploadError: null,
        currentStatus: null,
        uploadFieldName: 'photo'
      }
    },
    computed: {
      isInitial() {
        return this.currentStatus === STATUS_INITIAL;
      },
      isSaving() {
        return this.currentStatus === STATUS_SAVING;
      },
      isSuccess() {
        return this.currentStatus === STATUS_SUCCESS;
      },
      isFailed() {
        return this.currentStatus === STATUS_FAILED;
      }
    },
    methods: {
      reset() {
        // reset form to initial state
        this.currentStatus = STATUS_INITIAL;
        this.uploadedFiles = [];
        this.uploadError = null;
        console.log('reset');
      },
      uploadFiles(fieldName, fileList) {
        if (!fileList.length) return;

        var collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
        var sorted_fileList = [].slice.call(fileList).sort(function(a, b) {
          return collator.compare(a.name, b.name);
        });

        const url = this.getUrl()
        this.currentStatus = STATUS_SAVING;

        Array
          .from(sorted_fileList)
          .map((current_file, index) => {
            let formData = new FormData();
            let name = current_file.name
            formData.append(fieldName, current_file, name);
            let id = index + this.total + '_sort_element_' + name;
            let filesize = current_file.size / 1048576;

            if (filesize < 20) {
              axios.post(url, formData, {
                  onUploadProgress: progressEvent => {
                    // console.log(progressEvent);

                    const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
                    // console.log("onUploadProgress", progressEvent);
                    // console.log(name);
                    if (totalLength !== null) {
                      let progress = Math.round( (progressEvent.loaded * 100) / totalLength );
                      
                      this.$root.$emit('uploading_photo', this.type, {progress: progress, id: id, is_uploading: true, is_uploaded: false, name: name});
                    }
                  }
                })
                // get data
                .then(function (response) {
                  this.returnPhoto(response.data.data.photo, id);
                }.bind(this)).catch(err => {
                  let return_data = {
                    is_uploaded: false,
                    name: name,
                    id: Date.now()
                  };

                  if (err.response) {
                    try {
                      let reason = err.response.data.errors['photo'][0];
                      console.log(reason)
                      return_data.reason = reason;
                    } catch(err) {};

                    this.returnPhoto(return_data, id);
                  };
                });
              } else {
                let reason = this.$t('common.file_size_too_big');
                this.returnPhoto({id: id, is_uploaded: false, name: name, reason: reason}, id);
              }
            });

        this.currentStatus = STATUS_SUCCESS;
      },
      returnPhoto(data, id) {
        this.$root.$emit('uploaded_photo', this.type, data, id);
      },
      getUrl() {
        switch(this.type) {
          case TYPE_FLOOR_PLANS:
            return `/api/photos/upload-floor-plans/${this.listing_id}`;
            break;
          case TYPE_LISTING_PHOTOS:
            return `/api/photos/upload-listing-photos/${this.listing_id}`;
            break;
          case TYPE_GUEST_LISTING_PHOTOS:
            return `/guest/upload-listing-photos`;
            break;
        }
      },
    },
    mounted() {
      this.reset();
    },
  }
</script>